import React, { Component } from "react";

class ProfileInfo extends Component {
  render() {
    return (
      <div className="profile-info clearfix">
        <div className="form-element">
          <p className="title">Nombre de la empresa</p>
          <p className="label">PriceSmart</p>
          <div className="line"></div>
        </div>
        <div className="form-element">
          <p className="title">Límite de Sub-Facility</p>
          <p className="label">xxxxxxxxxxxxxxxxxxxxx</p>
          <div className="line"></div>
        </div>
        <div className="form-element">
          <p className="title"># CIF</p>
          <p className="label">26791</p>
          <div className="line"></div>
        </div>
        <div className="form-element">
          <p className="title">Número de Sub-Facility</p>
          <p className="label">xxxxxxxxxxxxxxxxxxxxx</p>
          <div className="line"></div>
        </div>
        <div className="form-element">
          <p className="title">RUC o Cédula Jurídica</p>
          <p className="label">3-102-987654</p>
          <div className="line"></div>
        </div>
        <div className="form-element">
          <p className="title">Tasa Base de Sub-Facility</p>
          <p className="label">xxxxxxxxxxxxxxxxxxxxx</p>
          <div className="line"></div>
        </div>
        <div className="form-element">
          <p className="title">Estado</p>
          <p className="label">Activo</p>
          <div className="line"></div>
        </div>
        <div className="form-element">
          <p className="title">Spread de Sub-Facility</p>
          <p className="label">xxxxxxxxxxxxxxxxxxxxx</p>
          <div className="line"></div>
        </div>
      </div>
    );
  }
}

export default ProfileInfo;
